import { delayPromise } from '@tableau/vizportalclient-common-components';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ERROR_NOTIFYING_SERVER_RESPONSE_DELAY } from '~src/httpClient/WebHttpClientWithErrorToast';

const setDescriptionConfig: Omit<JsonRestApiRequestConfig, 'endpoint'> = {
  restApiVersion: '3.5',
  httpMethod: 'PUT',
  serverWideRequest: false,
};

type SetDescription = {
  readonly description?: string;
};

type SetDescriptionBody = {
  readonly database: SetDescription;
} | {
  readonly table: SetDescription;
} | {
  readonly column: SetDescription;
}

type SetDescriptionParams = {
  readonly body: SetDescriptionBody;
  readonly luid: string;
} & ({
  readonly contentType: 'databases' | 'tables';
} | {
  readonly tableLuid: string;
  readonly contentType: 'columns';
})

function buildConfig(params: SetDescriptionParams): JsonRestApiRequestConfig {
    switch (params.contentType) {
      case 'columns':
        return { ...setDescriptionConfig, endpoint: `tables/${params.tableLuid}/columns/${params.luid}` };
      case 'databases':
      case 'tables':
        return { ...setDescriptionConfig, endpoint: `${params.contentType}/${params.luid}` };
    }
  }

export type ContentTypesWhichCanBeDescribed = 'database' | 'table' | 'column';

export async function setDescriptionForItem(params: SetDescriptionParams): Promise<IResult> {
    const result = await makeJsonRestApiRequest<SetDescriptionBody, {}>({
      config: buildConfig(params),
      request: params.body,
    });

    await delayPromise(ERROR_NOTIFYING_SERVER_RESPONSE_DELAY);
    return result;
  }